import { Component, h, State } from '@stencil/core';
import URLS from '../../app-root/urls';

@Component({
  tag: 'app-contact-form',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false
})
export class AppContactForm {
  @State() formControls = {
    name: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
    email: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
    telephone: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
    comment: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
  };
  @State() submitted = null;
  @State() showSubmitMessage = false;
  @State() UE: Function;
  @State() userengage: Function;
  @State() terms: boolean = null;

  // Once form is loaded we start validate all fields
  componentDidLoad() {
    // Set up name validate function
    this.formControls.name.validate = value => {
      if (value && value.length > 3) {
        return true;
      } else {
        return false;
      }
    };

    // Set up email validate function
    this.formControls.email.validate = value => {
      if (value && value.length > 6) {
        return true;
      } else {
        return false;
      }
    };

    // Set up telephone validate function
    this.formControls.telephone.validate = value => {
      if (value && value.length > 6) {
        return true;
      } else {
        return false;
      }
    };

    // Set up comment validate function
    this.formControls.comment.validate = value => {
      if (value && value.length > 2) {
        return true;
      } else {
        return false;
      }
    };
  }

  // Once inputs value is changing we start validate fields
  changeFormValue(controlName, value) {
    this.formControls = {
      ...this.formControls,
      [controlName]: {
        ...this.formControls[controlName],
        value: value,
        isValid: this.formControls[controlName].validate(value)
      }
    };
  }

  // Validate terms checkbox
  changeTerms(event: any) {
    this.terms = event.target.checked;
  }

  // Validate fields if value doesn't coincide
  validateFields() {
    this.submitted = false;

    if (this.formControls.name.value === null ||
      this.formControls.name.value === '') {
      this.formControls.name.isValid = false;
    }

    if (this.formControls.telephone.value === null ||
      this.formControls.telephone.value === '') {
      this.formControls.telephone.isValid = false;
    }

    if (this.formControls.email.value === null ||
      this.formControls.email.value === '') {
      this.formControls.email.isValid = false;
    }

    if (this.formControls.comment.value === null ||
      this.formControls.comment.value === '') {
      this.formControls.comment.isValid = false;
    }
  }

  /**
   * Fetch form url submit response
   */
  async handleSubmit(e) {
    e.preventDefault();

    // Send data to our url
    const data = {
      name: this.formControls.name.value,
      email: this.formControls.email.value,
      telephone: this.formControls.telephone.value,
      comment: this.formControls.comment.value,
    }

    const formData = new FormData()
    for(const name in data) {
      formData.append(name, data[name]);
    }

    if (this.terms) {
      fetch(process.env.BASEURL + 'api/form/contact', {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then((data) => {
        let isFormValid = true;
        this.submitted = true;

        if (data.result) {
          this.showSubmitMessage = true;

          /**
           * Determines user chat submit form
           */
          (this.UE as any).pageHit({
            apiKey: process.env.USERCHAT,
            first_name: this.formControls.name.value,
            phone_number: this.formControls.telephone.value,
            email: this.formControls.email.value,
          });

          (this.userengage as any)('event.Submitted Form', {
            apiKey: process.env.USERCHAT,
            first_name: this.formControls.name.value,
            phone_number: this.formControls.telephone.value,
            email: this.formControls.email.value,
          });

          /**
           * Determines datalayer form submission
           */
          let dataLayer = window.dataLayer;

          dataLayer.push({
            'event': 'formSubmission',
            'formType': 'Contact us',
            'formPosition': 'main-content'
          });

          if (isFormValid) {
            this.formControls.name.isValid = false;
            this.formControls.telephone.isValid = false;
            this.formControls.email.isValid = false;

            this.changeFormValue('name', '');
            this.changeFormValue('email', '');
            this.changeFormValue('telephone', '');
            this.changeFormValue('comment', '');
            this.changeFormValue('terms', false);

            this.submitted = false;
            isFormValid = false;
          }
        } else {
          this.showSubmitMessage = false;

          this.validateFields();

          // Run all validation functions
          for (let controlName in this.formControls) {
            let control = this.formControls[controlName];
            control.validate(control.value);

            if (!control.isValid) {
              isFormValid = false;
            }
          }
        }
      })
      .catch((item) => {
        if (!item.result) {
          for(const error in item.errors) {
            console.log('Please provide a value for ' + item.errors[error].field);
          }
        }
      });
    } else {
      this.terms = false;
      this.submitted = false;

      this.validateFields();
    }
  }

  render() {
    return (
      <form id='contact-form' onSubmit={(e) => this.handleSubmit(e)}>
        <div class='fieldset'>
          <h2 class='legend'>Wyślij zapytanie</h2>
          {
            this.showSubmitMessage ?
            <p class='success-message'>Formularz przesłany</p> :
            !this.showSubmitMessage ?
              <div>
                <ul class='form-list form-list--inline'>
                  <li class='fields'>
                    <label class='required'>Imie i nazwisko<em>*</em></label>
                    <input
                      name='name'
                      id='name'
                      title='Name'
                      type='text'
                      value={this.formControls.name.value}
                      onInput={(ev: any) =>
                        this.changeFormValue('name',
                        ev.target.value)
                      }
                    />
                    {
                      this.formControls.name.isValid === false &&
                      !this.submitted ?
                        <p
                          class='validation-advice'
                        >
                          To pole jest wymagane.
                        </p> :
                        null
                    }
                  </li>
                  <li>
                    <label class='required'>Adres email<em>*</em></label>
                    <input
                      name='email'
                      id='email'
                      title='Email address'
                      type='email'
                      value={this.formControls.email.value}
                      onInput={(ev: any) =>
                        this.changeFormValue('email',
                        ev.target.value)
                      }
                    />
                    {
                      this.formControls.email.isValid === false &&
                      !this.submitted ?
                        <p
                          class='validation-advice'
                        >
                          To pole jest wymagane.
                        </p> :
                        null
                    }
                  </li>
                  <li>
                    <label class='required'>Numer telefonu</label>
                    <input
                      name='telephone'
                      id='telephone'
                      title='Phone number'
                      class='input-text'
                      type='tel'
                      value={this.formControls.telephone.value}
                      onInput={(ev: any) =>
                        this.changeFormValue('telephone',
                        ev.target.value)
                      }
                    />
                  </li>
                  <li class='wide'>
                    <label class='required'>Twoje zapytanie<em>*</em></label>
                    <textarea
                      name='comment'
                      id='comment'
                      title='Your inquiry'
                      value={this.formControls.comment.value}
                      onInput={(ev: any) =>
                        this.changeFormValue('comment',
                        ev.target.value)
                      }
                    />
                    {
                      this.formControls.comment.isValid === false &&
                      !this.submitted ?
                        <p
                          class='validation-advice'
                        >
                          To pole jest wymagane.
                        </p> :
                        null
                    }
                  </li>
                  <li class='gdpr-conditions'>
                    <label>
                      <input
                        type='checkbox'
                        name='terms'
                        id='terms'
                        title='Terms of Use'
                        onChange={ (event) => this.changeTerms(event) }
                      />
                      Wyrażam zgodę na <a href={URLS.AppDataProtectionAndPrivacy} target="_blank">Przetwarzanie danych</a>
                    </label>
                    {
                      this.terms === false ?
                        <p
                          class='validation-advice'
                        >
                          To pole jest wymagane.
                        </p> :
                        null
                    }
                  </li>
                </ul>
                <div class='buttons-set'>
                  <button
                    type='submit'
                    title='Send Inquiry'
                    class='button'
                  >
                    Wysłać
                  </button>

                  <p class='required'>* Wymagane pola</p>
                </div>
              </div> :
              null
          }
        </div>
      </form>
    );
  }
}
